import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import { handleError } from '../../../../../ui/err/handleError';
import { deviceApis } from '../../../../../../shared/apis/device/apis';

export default function useExtendService() {
  const { mutate: extendServiceMutate } = useMutation(deviceApis.service.postExtendService, {
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });

  return { extendServiceMutate };
}
